import { render, staticRenderFns } from "./Block-User-Prompt.vue?vue&type=template&id=c234e502&scoped=true&"
import script from "./Block-User-Prompt.vue?vue&type=script&lang=js&"
export * from "./Block-User-Prompt.vue?vue&type=script&lang=js&"
import style0 from "./Block-User-Prompt.vue?vue&type=style&index=0&id=c234e502&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c234e502",
  null
  
)

export default component.exports